import { gql } from '@apollo/client';

export const PRICING_RUN_INSTANCE_FIELDS = gql`
    fragment PricingRunInstanceFields on pricing_run_instances {
        accessorials
        additional_parameters
        base_charge
        created_at
        destination_state
        destination_zip
        error
        instance_id
        last_modified_at
        leg_carrier_id
        margin_flat_charge
        margin_rate_charge
        origin_state
        origin_zip
        override_id
        run_id
        status
        subtotal_charge
        tariff_id
        total_charge
    }
`;
